export default {
    blog_text_1: "Naše ",
    blog_text_2: "blogy",
    blog_text_3: "Ostatné články",

    p_packages_text_1: "FUNKCIE DOFFERO",
    p_packages_text_2: "Čo získam",
    p_packages_text_3: "Neobmedzené ponuky",
    p_packages_text_4: "Neobmedzený počet klientov",
    p_packages_text_5: "Vlastné",
    p_packages_text_6: "Nastav si vlastné farby v dizajne ponuky.",
    p_packages_text_7: "farebné kombinácie",
    p_packages_text_8:
        "Môžeš vytvoriť používateľov, ktorí majú prístup k tvojmu účtu.",
    p_packages_text_9: "Pod-účty",
    p_packages_text_10: "pre kolegov, či zamestnancov",
    p_packages_text_11:
        "Pridaj si recenzie svojich klientov, ktoré budú súčasťou ponuky.",
    p_packages_text_12: "Recenzie",
    p_packages_text_13: "tvojich klientov v ponuke",
    p_packages_text_14: "Ponuky",
    p_packages_text_15:
        "Ak chceš, môžeš si skryť naše logo v tvojich ponukách.",
    p_packages_text_16: "bez loga",
    p_packages_text_17: "DOFFERO",
    p_packages_text_18:
        "PREMIUM používateľom ponúkame možnosť vypracovania vzhľadu cenovej ponuky na mieru.",
    p_packages_text_19: "Vlastné šablóny",
    p_packages_text_20: "cenovej ponuky",
    p_packages_text_21:
        "Možnosť prepnúť ponuku do angličtiny, nemčiny a češtiny",
    p_packages_text_22: "Možnosť vložiť obrázky k položkám",
    p_packages_text_23: "Možnosť nahrať",
    p_packages_text_24:
        "Nahraj dokumenty alebo súbory, ktoré si môže tvoj zákazník stiahnuť v online ponuke.",
    p_packages_text_25: "dokumenty na stiahnutie",
    p_packages_text_26: "Možnosť nastaviť si rôzne meny - EUR, CZK, USD, GBP",
    p_packages_text_27: "Možnosť vytvárať cenové ponuky pod rôznymi firmami",
    p_packages_text_28: "Možnosť prepojiť DOFFERO® na",
    p_packages_text_29: "SuperFaktura.sk",
    p_packages_text_30: "Chcem sa zaregistrovať zadarmo",
    p_packages_text_31: "Tvoj aktuálny balík",
    p_packages_text_32:
        "DOFFERO je aktuálne zadarmo so všetkými funkciami. Žiadne háčiky.",
    p_packages_text_33: "a čo ceny?",
    p_packages_text_34: "DOFFERO je",
    p_packages_text_35: "aktuálne pre",
    p_packages_text_36: "všetkých zadarmo",

    register_text_1: "Čo ti vieme ponúknuť?", // This line corresponds to the commented-out subtitle
    register_text_2: "Čo oceníš na cenových ponukách DOFFERO?",
    register_text_3: "Očarujúci dizajn",
    register_text_4: "Krásny",
    register_text_5: "dizajn",
    register_text_6: "Viac nových zákaziek",
    register_text_7: "Rýchla",
    register_text_8: "tvorba",
    register_text_9: "Prepracované šablóny",
    register_text_10: "Prispôsobiteľná",
    register_text_11: "farebnosť",
    register_text_12: "Schválenie na 1 klik",
    register_text_13: "Schválenie",
    register_text_14: "na 1 klik",
    register_text_15: "na základe dotazníkov od našich používateľov",
    register_text_16:
        "Appku som pouzil na cca 10 ponuk a z toho 7 bolo úspešnych. Uvidime, ako to pojde dalej. :)",
    register_text_17: "Matej, programátor",

    register_text_19: "Ty si ešte nevyskúšal/a naše cenové ponuky ZADARMO?",
    register_text_20: "Zmeň to! Stačí sa registrovať alebo sa",
    register_text_21: "prihlás",
    register_text_22: "Meno a priezvisko",
    register_text_23: "Email",
    register_text_24: "Heslo",
    register_text_25: "8 znakov",
    register_text_26: "1 veľké písmeno",
    register_text_27: "1 číslica",
    register_text_28: "Vytvoriť účet",
    register_text_29: "Prečítaj si prosím podmienky",
    register_text_30: "spracovania osobných údajov",

    validation_text_1: "Meno je potrebný údaj.",
    validation_text_2: "Email je potrebný údaj.",
    validation_text_3: "Zadajte spravný format emailu.",
    validation_text_4: "Email už existuje.",
    validation_text_5: "Heslo je potrebný údaj.",
    validation_text_6: "Heslo musí obsahovať viac ako 8 znakov.",
    validation_text_7: "Treba udeliť súhlas.",
    validation_text_8: "Názov spoločnosti je potrebný údaj.",

    login_text_1: "Doffero",
    login_text_2: "Vitaj s5!",
    login_text_3: "Nemáš ešte účet?",
    login_text_4: "Zaregistruj sa",
    login_text_5: "Zabudnuté heslo?",
    login_text_6: "Prihlásiť sa",
};
